import { Theme, Themed, WithTheme, cx, numberToPixels } from '@mint/core';
import React from 'react';
import styled from 'styled-components';

const DEFAULT_COMPONENT = 'div';

export interface AspectRatioSpacerProps
  extends React.HTMLAttributes<HTMLElement>,
    Themed {
  className?: string;
  component?: keyof React.ReactHTML | React.ComponentType;
  height?: number;
  width?: number;
}

const interpolateSize = ({
  height,
  width,
}: WithTheme<AspectRatioSpacerProps>): string => {
  if (typeof width === 'number' && typeof height === 'number') {
    const aspectRatio = width / height;
    return `padding-bottom: ${((1 / aspectRatio) * 100).toFixed(4)}%;`;
  } else {
    return '';
  }
};

const Component: React.FunctionComponent<AspectRatioSpacerProps> = ({
  children,
  className,
  component: Component = DEFAULT_COMPONENT,
  height,
  width,
  ...rest
}): React.ReactElement => {
  const componentProps = {
    className: cx(className, 'aspect-ratio-spacer'),
    ...rest,
  };

  return <Component {...componentProps}>{children}</Component>;
};

Component.displayName = 'AspectRatioSpacer';

export const AspectRatioSpacer = styled(Component)`
  ${interpolateSize}
`;
